module.exports = __webpack_public_path__ + "img/horizontal_4_4_2.297e24b1.png";